import styled, { keyframes } from "styled-components"

import { color } from "../../../atoms/colors"

export const Wrap = styled.div`
  position: relative;
  .background {
    position: absolute;
    bottom: 64px;
    left: 0;
    @media (max-width: 1400px) {
      left: 50%;
      transform: translate(-700px);
    }
    @media (max-width: 992px) {
      display: none;
    }
  }
`

export const GlobalTeamWrapper = styled.section`
  padding: 96px 15px;
  @media (max-width: 992px) {
    padding: 56px 15px;
  }
  @media (max-width: 576px) {
    padding: 40px 15px;
  }
`

export const Content = styled.div`
  max-width: 1170px;
  margin: 0 auto;
  @media (max-width: 992px) {
    max-width: 770px;
  }
  @media (max-width: 576px) {
    max-width: 506px;
  }
`

export const HeadingWrapper = styled.div`
  max-width: 770px;
  margin-bottom: 64px;
  @media (max-width: 992px) {
    margin-bottom: 48px;
  }
`

export const Heading = styled.h2`
  font-weight: 800;
  font-size: 48px;
  line-height: 60px;
  letter-spacing: -0.02em;
  color: ${color.oxfordBlue[900]};
  margin-bottom: 16px;
  @media (max-width: 992px) {
    font-size: 36px;
    line-height: 44px;
  }
  @media (max-width: 576px) {
    font-size: 30px;
    line-height: 38px;
  }
`

export const Body = styled.div`
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: ${color.copy[700]};
  margin-bottom: 16px;
  @media (max-width: 992px) {
    font-size: 16px;
  }
  .arrow-link {
    position: relative;
    text-decoration: none;
    font-weight: 700;
    font-size: 20px;
    padding-right: 15px;
    top: 8px;
    cursor: pointer;
    @media (max-width: 992px) {
      font-size: 16px;
    }
    &:hover {
      color: ${color.primary[200]};
    }
    &:before,
    &:after {
      border-right: 2px solid;
      content: "";
      display: block;
      height: 8px;
      margin-top: -6px;
      position: absolute;
      transform: rotate(135deg);
      right: 0;
      top: 54%;
      width: 0;
    }
    :after {
      margin-top: -1px;
      transform: rotate(45deg);
    }
  }
`

export const StatisticsWrapper = styled.div`
  max-width: 1330px;
  margin: 0 auto;
  padding: 48px 80px;
  display: grid;
  background: ${color.common.white};
  border: 4px solid ${color.primary[100]};
  border-radius: 80px 0px 80px 80px;
  grid-column-gap: 42px;
  grid-template-columns: ${(props) => props.num && `repeat(${props.num}, 1fr)`};
  @media (max-width: 992px) {
    border-radius: 40px 0px 40px 40px;
    grid-column-gap: 24px;
    max-width: 930px;
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    grid-row-gap: 16px;
    padding: 16px;
    border-radius: 24px 0px 24px 24px;
  }
  @media (max-width: 576px) {
    max-width: 538px;
  }
`

export const MapWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  pointer-events: none;
  .top-line {
    position: absolute;
    left: 50%;
    transform: translate(-440px);
    @media (max-width: 992px) {
      transform: none;
    }
    @media (max-width: 576px) {
      scale: 0.7;
      transform: translate(0, -90px);
    }
    @media (max-width: 375px) {
      scale: 0.5;
      transform: translate(0, -200px);
    }
  }
  .bottom-line {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(330px, 19px);
    @media (max-width: 992px) {
      display: none;
    }
  }
`

export const MapArea = styled.div`
  margin-top: 64px;
  width: fit-content;
  position: relative;
  @media (max-width: 992px) {
    margin-top: 48px;
  }
  svg {
    height: 100%;
    max-width: 100%;
  }
`

export const TipWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .flag {
    margin-bottom: 8px;
  }
`

export const Location = styled.span`
  padding: 16px;
  margin: -16px;
  display: inline-block;
  cursor: pointer;
  pointer-events: all;
  position: absolute;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  &.san-francisco {
    top: 43.6%;
    left: 18.2%;
  }
  &.atlanta {
    top: 44.6%;
    left: 33%;
  }
  &.toronto {
    top: 40.6%;
    left: 34%;
  }
  &.cape-town {
    top: 71.55%;
    left: 72.89%;
  }
  &.lagos {
    top: 55.25%;
    left: 66.62%;
  }
`

const pulseAnimation = keyframes`
  0% {
    box-shadow: 0 0 0 0px rgba(0, 196, 240);
  }
  100% {
    box-shadow: 0 0 0 10px rgba(0, 196, 240, 0);
  }
`

export const MapMark = styled.div`
  width: 8px;
  height: 8px;
  background: ${color.primary[400]};
  border-radius: 50%;
  animation: ${pulseAnimation} 2.5s infinite;
  opacity: 0.8;
`
